export default __webpack_public_path__ + "static/media/undraw_empty.f9d43e5d.svg";